import { initSharedPageInteractions } from './shared_page_interactions'
import { applyRebuildCompanyDetailAreaContext } from './rebuild_company_area_context'
import './tail-clamp-init'

export function initRebuildCompanySingle() {
  initSharedPageInteractions()
  applyRebuildCompanyDetailAreaContext()
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initRebuildCompanySingle)
} else {
  initRebuildCompanySingle()
}
